import {useRef} from "react";
import {useTexture} from "@react-three/drei";

export default function Floor(props) {
    const floor = useRef();

    // Floor
    const maps = useTexture({
        map: './floor/PavingStones092_1K_Color.jpg',
        displacementMap: './floor/PavingStones092_1K_Displacement.jpg',
        normalMap: './floor/PavingStones092_1K_NormalGL.jpg',
        roughnessMap: './floor/PavingStones092_1K_Roughness.jpg',
        aoMap: './floor/PavingStones092_1K_AmbientOcclusion.jpg',
    })

    return <mesh rotation-x={ -Math.PI/2 } position={[ 0, 0-props.viewport.height/2, -5 ]}>
        <planeGeometry args={[props.viewport.width*2, props.viewport.height*2]} />
        <meshStandardMaterial {...maps} />
    </mesh>
}